import { createSelector } from 'reselect';
import { constants as cloudTypeConstants } from '@saucelabs/sl-module-cloudtype';

import { eventMetaDataSelector } from './common/selectors';

export const propsSelector = createSelector([
  (store, props) => props,
], (props) => ({
  isOpenSauceUser: props?.isOpenSauceUser,
  isSubaccountDashboard: props?.isSubaccountDashboard,
  username: props?.match?.params?.username,
  cloudType: props?.match?.params?.cloudType || cloudTypeConstants.DEFAULT_CLOUD_TYPE,
}));

export const containerSelector = createSelector([
  (store) => store.apps.jobs,
  (store) => store.user,
  eventMetaDataSelector,
  propsSelector,
],
(jobs, user, eventMetaData, {
  isOpenSauceUser,
  isSubaccountDashboard,
  username,
  cloudType,
}) => ({
  buildsLoading: jobs.flatBuilds.common.get('vdcBuildsLoading'),
  filters: jobs.filters,
  filtersInitialized: jobs.filters.get('filtersInitialized'),
  isOpenSauceUser: isOpenSauceUser || !user.isAuthenticated(),
  jobsTeamSharingEnabled: jobs.users.get('user').organization.settings ?
    jobs.users.get('user').organization.settings.jobs_cross_team_sharing :
    true,
  jobsTeamSharingFeatureEnabled: !isOpenSauceUser,
  organizationId: jobs.users.get('user').organization.id || user.organization.id,
  orgTeams: jobs.filters.get('orgTeams'),
  orgUsers: jobs.filters.get('orgUsers'),
  orgUsersWithIds: jobs.filters.get('orgUsersWithIds'),
  shouldFetchOrgUsers: !isOpenSauceUser && !isSubaccountDashboard && user.isAuthenticated(),
  shouldFetchUserIds: !isOpenSauceUser && user.isAuthenticated(),
  user: jobs.users.get('user'),
  username: username || jobs.users.get('user').username,
  loggedInUser: user,
  eventMetaData: {
    ...eventMetaData,
    sku_type: cloudType.toUpperCase(),
  },
}));

export default containerSelector;
